import React from 'react'
import { Typography, Grid, Box, StepLabel, StepContent } from '@mui/material'

import { I18n } from '@front/volcanion/'

import {
  SingleOptionSelectorField,
  TextField,
  ModelMenuSelectorField,
  ModelAutocompleteField,
  NumberField
} from '@front/squirtle/'

const Row1 = ({ onTypeChange, display_poi_client_id }) => {
  return (
    <Grid container spacing={1} alignItems='flex-end' size={12}>
      <Grid size={1}>
        <SingleOptionSelectorField
          name='active'
          label={I18n.t('active')}
        />
      </Grid>
      <Grid size={3}>
        <ModelMenuSelectorField
          name='type'
          label={I18n.t('type.label', { count: 1 })}
          model_name='poitype'
          labelKeys={['name_translated']}
          searchMode={'search'}
          loadOnMount
          config={{ force_filter: { active: true } }}
          required
          afterChange={onTypeChange}
        />
      </Grid>
      <Grid hidden={!display_poi_client_id} size={1}>
        <TextField
          name={'poi_client_id'}
          label={I18n.t('poi.client_id')}
          type='number'
        />
      </Grid>
      <Grid size={4}>
        <ModelAutocompleteField
          name='city_polygon'
          label={I18n.t('city.label', { count: 1 })}
          model_name='city'
          labelKeys={['name']}
          searchMode='search'
          searchQuery='contains'
          autocompleteKey='name'
        />
      </Grid>
      <Grid size="grow">
        <SingleOptionSelectorField
          name='required_additional_info'
          label={I18n.t('poi.required_additional_info')}
        />
      </Grid>
      <Grid size="grow">
        <NumberField
          name='planned_fee'
          label={I18n.t('poi.planned_fee')}
          type='float'
          minValue={0}
          InputProps={{
            inputProps: { style: { textAlign: 'right' } },
            endAdornment: <Typography sx={{ fontSize: 'subtitle.fontSize', color: 'text.label' }}> {I18n.t('fiat.eur.sign')} </Typography>
          }}
        />
      </Grid>
    </Grid>
  );
}

const PrimarySection = (props) => <>
  <StepLabel>
    <Typography variant='h5'>{I18n.t('info.general')}</Typography>
  </StepLabel>
  <StepContent >
    <Box sx={{ p: 3, boxShadow: 6, borderRadius: 1 }}>
      <Grid container rowSpacing={3}>
        <Row1 {...props} />
      </Grid>
    </Box>
  </StepContent>
</>

export default React.memo(PrimarySection)
